// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"392b9df4","961":"ab72dc4b"}[chunkId] + ".chunk.js";
};